import { Injectable } from '@angular/core';

import {Apollo} from 'apollo-angular';
import{map}from 'rxjs/operators'; 
import {global} from '../../../graphqlserver/conection';
import * as gqlConfig from '../graphql/gql_configuracion';
import { Configmodel } from '../models/configuracion';
import * as moment from 'moment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {

  constructor(private apollo:Apollo,private http:HttpClient) { }

  listaconfiguracion(){
    return this.apollo.watchQuery<any>({
      query: gqlConfig.gql_listaconfig
    }).valueChanges.pipe(map(result => result.data.listaConfig));
  }

  actualizaconfig(datos:Configmodel){
    return this.apollo.mutate({
      mutation: gqlConfig.gql_actualizaConfig,
      variables:{datos}
    })
  }

  getReporteBiotime(){
    return this.http.get<any>(`${global.urlgraph}/feriados`);
  }

}
